var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.006,
    height: 17.229,
    viewBox: "0 0 26.006 17.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M24.879,23.5a3,3,0,0,1,3.295,3.247V37.376a3.077,3.077,0,0,1-3.288,3.351H13.4a3.08,3.08,0,0,1-3.4-3.24V26.863A3.127,3.127,0,0,1,13.293,23.5H24.879Zm9.76,1.623A1.337,1.337,0,0,1,36,26.514l0,.084V37.631a1.349,1.349,0,0,1-1.367,1.475,1.806,1.806,0,0,1-1.088-.453l-.078-.066-3.858-3.342v-6.27l3.858-3.331A1.863,1.863,0,0,1,34.639,25.123Z",
    transform: "translate(-10 -23.5)",
    fill: "#093549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.c38b9794541d88b64d62c6c35df6d24a.svg";
export { ForwardRef as ReactComponent };